// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--3tGUD","hero__img":"hero-module--hero__img--1ez7J","hero__text":"hero-module--hero__text--3NI7n"};